import { css } from 'linaria';

export const headerSection = css`
  && {
    margin-bottom: 64px;

    @media (--only-mobile) {
      margin-bottom: 40px;
    }
  }
`;

export const headerTitle = css`
  && {
    width: 500px;
    margin-bottom: 24px;

    @media (--to-desktop) {
      width: 100%;
    }

    @media (--only-mobile) {
      margin-bottom: 16px;
    }
  }
`;

export const headerContent = css`
  display: flex;
  align-items: flex-start;

  @media (--to-desktop) {
    flex-direction: column;
  }
`;

export const headerText = css`
  && {
    width: 670px;
    margin-right: 37px;

    @media (--only-desktop) {
      width: 530px;
      margin-right: 32px;
    }

    @media (--to-desktop) {
      width: 100%;
      margin-right: 0;
      margin-bottom: 32px;
    }

    @media (--only-mobile) {
      margin-bottom: 24px;
    }
  }
`;

export const headerListItem = css`
  && {
    &:not(:last-of-type) {
      margin-bottom: 16px;

      @media (--only-mobile) {
        margin-bottom: 12px;
      }
    }

    &:last-of-type {
      margin-bottom: 0;
    }

    @media (--only-mobile) {
      align-items: flex-start;
    }
  }
`;

export const headerListIcon = css`
  && {
    margin-right: 12px;

    @media (--only-mobile) {
      width: 20px;
      height: 20px;
    }
  }
`;
